import { ProgramList } from './program-list';
import { RowInputType } from './row-input-type';
import { UploadLookup } from './upload-lookup.interface';
const diaName = ProgramList.dia;
export const AishAssetTypes: { [name: string]: UploadLookup } = {
  bankAccountCount: {
    displayValue: 'Number of bank accounts',
    documentTypes: ['Number of bank accounts'],
    needSupportDocument: false,
    order: 0,
    inputType: RowInputType.Counter,
  },
  bankAccounts: {
    displayValue: 'Bank account balance',
    documentTypes: ['Statement from bank account'],
    categoryTitleOverride: 'Proof of bank account balance',
    needSupportDocument: true,
    valueZeroRequiresDocument: true,
    order: 1,
    inputType: RowInputType.DollarValue,
  },
  insurance: {
    displayValue: 'Life insurance',
    documentTypes: ['Life insurance'],
    categoryTitleOverride: 'Proof of life insurance',
    needSupportDocument: true,
    order: 2,
    inputType: RowInputType.DollarValue,
  },
  termDeposits: {
    displayValue: 'Term deposits',
    documentTypes: ['Bank statement'],
    categoryTitleOverride: 'Proof of term deposits',
    needSupportDocument: true,
    order: 3,
    inputType: RowInputType.DollarValue,
  },
  tfsa: {
    displayValue: 'Tax-Free Savings Account (TFSA)',
    documentTypes: ['Bank statement', 'Investment statements (showing the current market value)'],
    categoryTitleOverride: 'Proof of Tax-Free Savings Account (TFSA)',
    needSupportDocument: true,
    order: 4,
    inputType: RowInputType.DollarValue,
  },
  rrsp: {
    displayValue: 'Registered Retirement Savings Plan (RRSP)',
    documentTypes: ['Bank statement', 'Investment statements (showing the current market value)'],
    categoryTitleOverride: 'Proof of Registered Retirement Savings Plan (RRSP)',
    needSupportDocument: true,
    order: 5,
    inputType: RowInputType.DollarValue,
  },
  gic: {
    displayValue: 'Guaranteed Investment Certificate (GIC)',
    documentTypes: ['Bank statement', 'Investment statements (showing the current market value)'],
    categoryTitleOverride: 'Proof of Guaranteed Investment Certificate (GIC)',
    needSupportDocument: true,
    order: 6,
    inputType: RowInputType.DollarValue,
  },
  rrif: {
    displayValue: 'Registered Retirement Income Fund (RRIF)',
    documentTypes: ['Bank statement', 'Investment statements (showing the current market value)'],
    categoryTitleOverride: 'Proof of Registered Retirement Income Fund (RRIF)',
    needSupportDocument: true,
    order: 7,
    inputType: RowInputType.DollarValue,
  },
  annuities: {
    displayValue: 'Annuities',
    documentTypes: ['Bank statement', 'Investment statements (showing the current market value)'],
    categoryTitleOverride: 'Proof of annuities',
    needSupportDocument: true,
    order: 8,
    inputType: RowInputType.DollarValue,
  },
  lira: {
    displayValue: 'Locked-In Retirement Account (LIRA)',
    documentTypes: ['Bank statement', 'Investment statements (showing the current market value)'],
    categoryTitleOverride: 'Proof of Locked-In Retirement Account (LIRA)',
    needSupportDocument: true,
    order: 9,
    inputType: RowInputType.DollarValue,
  },
  rdsp: {
    displayValue: 'Registered Disability Savings Plan (RDSP)',
    documentTypes: ['Bank statement', 'Investment statements (showing the current market value)'],
    categoryTitleOverride: 'Proof of Registered Disability Savings Plan (RDSP)',
    needSupportDocument: true,
    order: 10,
    inputType: RowInputType.DollarValue,
  },
  resp: {
    displayValue: 'Registered Education Savings Plan (RESP)',
    documentTypes: ['Bank statement', 'Investment statements (showing the current market value)'],
    categoryTitleOverride: 'Proof of Registered Education Savings Plan (RESP)',
    needSupportDocument: true,
    order: 11,
    inputType: RowInputType.DollarValue,
  },
  stocksAndBonds: {
    displayValue: 'Stocks and/or bonds',
    documentTypes: ['Bank statement', 'Investment statements (showing the current market value)'],
    categoryTitleOverride: 'Proof of stocks and/or bonds',
    needSupportDocument: true,
    order: 12,
    inputType: RowInputType.DollarValue,
  },
  trustFunds: {
    displayValue: 'Trust funds',
    documentTypes: ['Bank statement', 'Investment statements (showing the current market value)'],
    categoryTitleOverride: 'Proof of trust funds',
    needSupportDocument: true,
    order: 13,
    inputType: RowInputType.DollarValue,
  },
  other: {
    displayValue: 'Other investment(s)',
    documentTypes: ['Other investment(s)'],
    categoryTitleOverride: 'Proof of other investment(s)',
    needSupportDocument: true,
    order: 14,
    inputType: RowInputType.DollarValue,
  },
  uncashedChequesOrCashOnHand: {
    displayValue: 'Uncashed cheques or cash on hand',
    documentTypes: ['Uncashed cheques or cash on hand'],
    categoryTitleOverride: 'Proof of uncashed cheques or cash on hand',
    needSupportDocument: false,
    order: 15,
    inputType: RowInputType.DollarValue,
  },
};
